<template>
    <HomeTopComponent/>
    <template v-if="isMounted">
<!--        <PriceList/>-->
        <HomeCatalogNavigation/>
        <CompanyGuarantees/>
        <CallbackDarkForm/>
        <OfficialLicense/>
        <HowToBuy/>
        <WhyWeFirst/>
        <WeHaveBestPrices/>
        <FeedbackPlatforms/>
        <Feedbacks class="pt-20"/>
        <CallbackBigForm/>
        <HomeFaq/>
    </template>
</template>

<script>
import {useThemeStore} from "@/js/store/ThemeStore.js";
import PriceList from "@js/components/Sections/PriceList/PriceList.vue";
import CallbackDarkForm from "@js/components/Sections/Callback/CallbackDarkForm.vue";
import OfficialLicense from "@js/components/Sections/Licenses/OfficialLicense.vue";
import HowToBuy from "@js/components/Sections/HowToBuy/HowToBuy.vue";
import CompanyGuarantees from "@js/components/Sections/InfoCards/CompanyGuarantees.vue";
import WhyWeFirst from "@js/components/Sections/InfoCards/WhyWeFirst.vue";
import WorkingSince from "@js/components/Sections/Home/WorkingSince.vue";
import WeHaveBestPrices from "@js/components/Sections/Home/WeHaveBestPrices.vue";
import FeedbackPlatforms from "@js/components/Sections/Feedbacks/FeedbackPlatforms.vue";
import Feedbacks from "@js/components/Sections/Feedbacks/Feedbacks.vue";
import HomeFaq from "@js/components/Sections/Faqs/HomeFaq.vue";
import CallbackBigForm from "@js/components/Sections/Callback/CallbackBigForm.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import HomeTopComponent from "@js/components/Sections/TopComponents/HomeTopComponent.vue";
import HomeCatalogNavigation from "@js/components/Sections/Home/HomeCatalogNavigation.vue";

export default {
    name: 'Home',
    components: {
        HomeCatalogNavigation,
        HomeTopComponent,
        OnlyDesktop,
        CallbackBigForm,
        HomeFaq,
        Feedbacks,
        FeedbackPlatforms,
        WeHaveBestPrices,
        WorkingSince,
        WhyWeFirst,
        CompanyGuarantees,
        HowToBuy,
        OfficialLicense,
        CallbackDarkForm,
        PriceList,
    },
    data() {
        return {
            is_hovered: false,
            isMounted: false,
        };
    },
    beforeMount() {
        this.themeStore.activateLightTheme()
    },
    setup() {
        const themeStore = useThemeStore()

        return {themeStore}
    },
    mounted() {
        this.isMounted = true
    }
};
</script>

<style lang="scss">

</style>
